export const STORE_COMPETITORS_AVG_MONTHLY_PRICES = 'competitorsMonthlyAvgPrices';
export const CMAP_SET_OPTIONS = 'setOptions';
export const CMAP_SET_FILTERS = 'setFilters';
export const CMAP_FETCH_DATA = 'fetchData';
export const CMAP_DEFAULT_YEAR = 1;
